import { Divider, Stack, Text } from '@mantine/core';
import type { ReactNode } from 'react';

export function DetailSection({
    title,
    description,
    children,
}: {
    title: string;
    description?: string;
    children: ReactNode;
}) {
    return (
        <Stack gap="sm">
            <div>
                <Text fw={600} size="sm">
                    {title}
                </Text>
                {description ? (
                    <Text size="xs" c="dimmed">
                        {description}
                    </Text>
                ) : null}
            </div>
            {children}
            <Divider />
        </Stack>
    );
}
